import './StreamingReports.scss';
import { Page } from '@Components/Page/Page';
import { useTabbedNav } from '../../utils/hooks/useNav';
import { FlashtalkingReport } from './FlashtalkingReport';
import { InvalidRotationsReport } from './InvalidRotationsReport';
import { NonLiveReport } from './NonLiveReport';

const NON_LIVE_KEY = 'nonlive';
const INVALID_ROTATION_KEY = 'invalid-rotations';
const FT_REPORT_KEY = 'ft-sync';

const NAVS = [NON_LIVE_KEY, INVALID_ROTATION_KEY, FT_REPORT_KEY] as const;
type NavKey = (typeof NAVS)[number];

export const StreamingReports = () => {
  const { tab, goToTab } = useTabbedNav<NavKey>({
    baseURL: 'streaming/reports',
    defaultKey: NON_LIVE_KEY,
    navs: [...NAVS]
  });

  return (
    <Page
      title='Streaming Reports'
      pageType='Streaming Reports'
      navs={[
        { label: 'Non-Live', key: NON_LIVE_KEY },
        { label: 'Invalid Rotations', key: INVALID_ROTATION_KEY },
        { label: 'FT vs BPM', key: FT_REPORT_KEY }
      ]}
      selectedNav={tab}
      onNav={nav => goToTab(nav as NavKey)}
    >
      <div className='streaming-reports-page'>
        {tab === NON_LIVE_KEY && <NonLiveReport />}
        {tab === INVALID_ROTATION_KEY && <InvalidRotationsReport />}
        {tab === FT_REPORT_KEY && <FlashtalkingReport />}
      </div>
    </Page>
  );
};
